import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
// import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';

/*
  Generated class for the MessageSeviceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MessageSeviceProvider {

  constructor(
    private socket: Socket
    ) {
    console.log('Hello MessageSeviceProvider Provider');
  }

  public sendMessage(key: string, message: any) {
    // this.socket.emit(key, message);
  }

  public getMessages(key: string): Observable<any> {
    return Observable.create((observer: any) => {
      this.socket.on(key, (message: any) => {
        observer.next(message);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/message-sevice/message-sevice.ts